<!-- .nav-item from bootstrap and scss/_nav.scss -->
<div class="nav-item">
    <!-- .cmps-nav-icon from bootstrap and scss/_nav.scss -->
    <button
        class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white cmps-nav-icon cmps-cdk-flex-column cmps-cdk-pos-relative"
        [class.active]="_dialogService.isOpen"
        cmpsIconButton
        tabindex="0"
        role="menuitem"
        (click)="
            _dialogService.toggle(
                _dialogService.state?.categories?.[0]?.categoryId
            )
        "
    >
        <div
            class="cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0 cmps-cdk-pos-bottom-0 cmps-cdk-pos-left-0 cmps-cdk-z-index-1"
            [cmpsTooltipTrigger]="_dialogService.state?.categories?.[0]?.label"
            placement="bottom-center"
            [openDelay]="1000"
        ></div>

        <!-- TODO revise padding after all nav icons have changed to mdi (cmps-icon) icons -->
        <div
            class="cmps-cdk-pt-0dot25"
            [cmpsBadge]="
                _dialogService.state?.categories?.[0]?.unreadCountLabel
            "
            cmpsBadgePlacement="bottom-right"
            [cmpsBadgeHidden]="
                _dialogService.state?.categories?.[0]?.unreadCount <= 0
            "
            cmpsBadgeClassName="cmps-cdk-bg-color-red-100"
        >
            <cmps-icon svgIcon="email-outline"></cmps-icon>
        </div>

        <!-- .line from scss/_nav.scss -->
        <div class="line"></div>
    </button>
</div>
